import { HttpClient } from 'aurelia-fetch-client';
import { autoinject, resolve } from 'aurelia-framework';

@autoinject
export class ApiService {
  private httpClient = resolve(HttpClient);
  private serviceAliases: Record<string, string> = {
    'inboxv2-api': 'inbox-minapi'
  };
  private serviceUrls: Map<string, string>;

  private async getOkOrEmpty(url: string) {
    return this.httpClient.get(`/config/${url}`).then(r => r.ok ? r.text() : '').catch(() => '');
  }

  async init() {
    if (this.serviceUrls) {
      return;
    }
    const [routing, namespace, domain, services, natsUrl] = await Promise.all(
      ['routing', 'namespace', 'domain', 'services'].map(x => this.getOkOrEmpty(x))
    );
    const mode = routing === 'path' ? 'path' : 'subdomain';
    this.serviceUrls = new Map(await Promise.all(services.split(',').map(async service => {
      const [serviceDomain, revision, basePath] = await Promise.all([
        this.getOkOrEmpty(`service.${service}.domain`),
        this.getOkOrEmpty(`service.${service}.apiRevision`),
        this.getOkOrEmpty(`service.${service}.basePath`)
      ]);
      let url = '';
      if (mode === 'path') {
        url = basePath;
      } else if (namespace) {
        url = `https://${revision}${revision ? '-' : ''}${service}-${namespace}.${serviceDomain || domain}`;
      }
      return [service, url] as [string, string];
    })));
  }

  getServiceUrl(service: string): string {
    return this.serviceUrls.get(this.serviceAliases[service] ?? service) ?? '';
  }
}
